import React, {useCallback, useState} from "react"

import FieldProto from "../../../../../../../../../core/fields3/proto/field-proto"
import FieldHelp from "../../../../../../../../../core/gd-components/help-and-hint/field-help/field-help"

type Props = {
    field           : FieldProto
    title?          : string
    description?    : string
}

export default function AddViewRowTitle(props: Props) {

    const [showHelp, setShowHelp] = useState(false)

    const onMouseEnter = useCallback(()=>{
        setShowHelp(true)
    }, [])

    const onMouseLeave = useCallback(()=>{
        setShowHelp(false)
    }, [])

    const helpMessage = props.description || props.field.description

    return (
        <div className="flex-row-left-center w-100-percent h-22 m-b-8" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <div className="ui5-txt-not-important-small">{props.title || props.field.label}</div>

            {(showHelp && helpMessage) &&
                <FieldHelp className    = "m-l-8"
                           message      = {props.description || props.field.description}/>}
        </div>
    )
}